var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22.75c-3.44 0-5.75-2.31-5.75-5.75v-5c0-3.08 1.9-5.31 4.85-5.68.28-.04.59-.07.9-.07h10c.24 0 .55.01.87.06 2.95.34 4.88 2.58 4.88 5.69v5c0 3.44-2.31 5.75-5.75 5.75H7zM6.3 7.8c-2.2.28-3.55 1.88-3.55 4.2v5c0 2.58 1.67 4.25 4.25 4.25h10c2.58 0 4.25-1.67 4.25-4.25v-5c0-2.34-1.37-3.95-3.59-4.21-.24-.04-.45-.04-.66-.04H7c-.24 0-.47.02-.7.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58 7.5a.735.735 0 0 1-.06-.78c.17-.34.41-.67.72-.97l3.25-3.26a4.28 4.28 0 0 1 6.02 0l1.75 1.77c.74.73 1.19 1.71 1.24 2.75a.752.752 0 0 1-.87.78c-.2-.03-.41-.04-.63-.04H7c-.24 0-.47.02-.7.05-.03.01-.07.01-.11.01-.24 0-.46-.11-.61-.31zm11.24-1.25c-.13-.34-.34-.65-.62-.93l-1.76-1.78c-1.07-1.06-2.82-1.06-3.9 0L7.86 6.25h8.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17.25c-1.52 0-2.75-1.23-2.75-2.75s1.23-2.75 2.75-2.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3a1.25 1.25 0 0 0 0 2.5h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineWallet);
export default __webpack_public_path__ + "static/media/vuesax-outline-wallet.2bb0997517ef69c68e14bf7c476315b8.svg";
export { ForwardRef as ReactComponent };